import {
  getButtonRootProps,
  type GetButtonRootPropsResult,
} from './getButtonRootProps.ts';
import {
  getOrderRootProps,
  type GetOrderRootPropsResult,
} from './getOrderRootProps.ts';
import {
  getPluginRootProps,
  type GetPluginRootPropsResult,
} from './getPluginRootProps.ts';
import { PLUGIN_TYPE_ENUM } from '../../PluginType.ts';
import type { PluginParams } from '../params/PluginTypeParams.ts';

const pluginTypeToFunctionMap = {
  [PLUGIN_TYPE_ENUM.BUTTON]: getButtonRootProps,
  [PLUGIN_TYPE_ENUM.ORDER]: getOrderRootProps,
  [PLUGIN_TYPE_ENUM.PLUGIN]: getPluginRootProps,
} as const;

type GetPropsByPluginTypeResult<T extends PLUGIN_TYPE_ENUM> =
  T extends PLUGIN_TYPE_ENUM.BUTTON
    ? GetButtonRootPropsResult
    : T extends PLUGIN_TYPE_ENUM.ORDER
      ? GetOrderRootPropsResult
      : T extends PLUGIN_TYPE_ENUM.PLUGIN
        ? GetPluginRootPropsResult
        : never;

type GetPropsByPluginTypeArgs<T extends PLUGIN_TYPE_ENUM> = {
  pluginType: T;
  params: PluginParams<T>;
};

type GetPropsByPluginTypeFunction<T extends PLUGIN_TYPE_ENUM> = (
  params: PluginParams<T>,
) => GetPropsByPluginTypeResult<T>;

export const getPropsByPluginType = <T extends PLUGIN_TYPE_ENUM>({
  pluginType,
  params,
}: GetPropsByPluginTypeArgs<T>): GetPropsByPluginTypeResult<T> => {
  const handler = pluginTypeToFunctionMap[
    pluginType
  ] as unknown as GetPropsByPluginTypeFunction<T>;

  return handler(params);
};
